export class DeadlineToday {
  public productTypeName: string;
  public deadLine: Date;

  public timeString: string;
  public deadLineStillOk: boolean;
}
